import { render, staticRenderFns } from "./CampaignSummaryDialog.vue?vue&type=template&id=dd1218d0"
import script from "./CampaignSummaryDialog.vue?vue&type=script&lang=ts"
export * from "./CampaignSummaryDialog.vue?vue&type=script&lang=ts"
import style0 from "./CampaignSummaryDialog.vue?vue&type=style&index=0&id=dd1218d0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports